import {Component, OnInit} from '@angular/core';
import {AlertService} from './alert.service';
import {Alert, AlertType} from './alert';
import sweetAlert from 'sweetalert2';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    standalone: false
})
export class AlertComponent implements OnInit {

    alertMsg;
    displayMessage: string;
    alertType: string;
    customizedAlert: any;

    constructor(private toastyService: AlertService) { }

    ngOnInit() {
        this.toastyService.getAlert().subscribe((message) => this.getAlertMsg(message));
    }



    getAlertMsg(alert: Alert) {
        if (!alert) {
            return;
        }
        this.customizedAlert = sweetAlert.mixin({
            customClass: {
              confirmButton: 'usa-button',
              cancelButton: 'usa-button usa-button--outline',
              closeButton: ' usa-button usa-button--secondary'
            },
            buttonsStyling: false
          });

        // setting alert message
        this.displayMessage = alert.message;

        // return css class based on alert type
        switch (alert.type) {
            case AlertType.Success:
                this.alertType = 'success';
                sweetAlert.fire({
                    type: 'success',
                    title:"<span class='font-alt-md'>"+ this.displayMessage + "</span>",
                    timer: 2000,
                    showConfirmButton: false
                });
                break;
            case AlertType.Success2:
                this.alertType = 'success';
                this.customizedAlert.fire({
                    type: 'success',
                    iconColor:'#005ea2',
                    title:"<span class='font-alt-md'>"+this.displayMessage + "</span>",
                    showCloseButton: false,
                    buttonsStyling: false
                });
                break;
            case AlertType.Error:
                this.alertType = 'danger';
                this.customizedAlert.fire({
                    type: 'error',
                   // timer: 10000,
                    title: "<span class='font-alt-md'>"+ this.displayMessage + "</span>",
                    showConfirmButton: true,
                    showCloseButton: false,
                    buttonsStyling: false
                });
                break;
            case AlertType.Info:
                this.alertType = 'info';
                sweetAlert.fire({
                    type: 'info',
                    title:  "<span class='font-alt-md'>"+ this.displayMessage + "</span>",
                    timer: 2000,
                    showConfirmButton: false
                });
                break;
            case AlertType.Warning:
                this.alertType = 'warning';
                sweetAlert.fire({
                    type: 'warning',
                    title: "<span class='font-alt-md'>"+ this.displayMessage + "</span>",
                    timer: 2000,
                    showConfirmButton: false
                });
                break;
            case AlertType.Information:
                this.alertType = 'info';
                this.customizedAlert.fire({
                    type: 'info',
                    title:"<span class='font-alt-md'>"+ this.displayMessage + "</span>",
                    showConfirmButton: false,
                    showCloseButton: true
                });
                break;
        }
        // Setting timeout msg for 5 sec
        setTimeout(() => { this.displayMessage = null; }, 2700);
    }

}
